import {
  DAY_SUMMARY_LIST_ALL,
  DAY_SUMMARY_LIST_GET,
  DAY_SUMMARY_LIST_POST,
  DAY_SUMMARY_LIST_PUT,
  DAY_SUMMARY_LIST_LOADING,
  DAY_SUMMARY_LIST_ERROR,
} from '../../actions/types';

const initialState = {
  daySummaryList: null,
  isLoading: true,
  isCompleted: true,
};
// eslint-disable-next-line func-names
export default function (state = initialState, action) {
  switch (action.type) {
    case DAY_SUMMARY_LIST_LOADING:
      return { isLoading: true, isCompleted: true };
    case DAY_SUMMARY_LIST_ERROR:
      return { isLoading: false, isCompleted: false, ...action.payload };
    case DAY_SUMMARY_LIST_ALL:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case DAY_SUMMARY_LIST_GET:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case DAY_SUMMARY_LIST_POST:
      return { isLoading: false, isCompleted: true };
    case DAY_SUMMARY_LIST_PUT:
      return { isLoading: false, isCompleted: true };
    default:
      return state;
  }
}
